import { defineComponent as _defineComponent } from 'vue'
import SideMenu from 'Src/js/components/SideMenu.vue';
import TireRecommender from './recommender/TireListRecommender';
import { ICustomerVehicle } from 'JS/types/Automotive';
import { ref, watch } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TireListRecommendationSidebar',
  props: {
    show: { type: Boolean },
    vehicle: null
  },
  setup(__props: any) {

const props = __props as {
	show?: boolean;
	vehicle: ICustomerVehicle;
}



// While the SideMenu default slot is conditionally rendered, and components in the slot
// are usually lazily evaluated (not mounted if !isOpen), that doesn't seem to hold for
// async components. This tracks whether or not this menu has been shown and conditionally
// renders the child component based on that. That keeps the lazy behavior for a) loading
// and b) remounting the component when show/isOpen changes
const allowComponentLazyLoad = ref(false);
watch(() => props.show, show => {
	if (show && !allowComponentLazyLoad.value) {
		allowComponentLazyLoad.value = true;
	}
});


return { __sfc: true,props, allowComponentLazyLoad, SideMenu, TireRecommender }
}

})